<template>
    <div
        class="relative register bg-cover bg-center bg-no-repeat px-3 pt-40 pb-20 z-10"
    >
        <div
            class="relative flex flex-col items-center max-w-screen-sm mx-auto border-2 border-orange p-6 sm:p-16 bg-white mb-6"
        >
            <back-button></back-button>

            <div class="flex flex-col items-center mb-12">
                <brush-stroke-bg>
                    <h2
                        class="font-primary text-3xl text-white font-semibold py-2 pr-3 sm:pr-6"
                    >
                        {{ $config("C_USUARIO") }}
                    </h2>
                </brush-stroke-bg>
            </div>

            <ValidationObserver v-slot="{ handleSubmit }" class="w-full">
                <form
                    class="flex flex-col"
                    @submit.prevent="handleSubmit(register)"
                    novalidate
                >
                    <form-input
                        name="name"
                        v-model="name"
                        type="text"
                        :placeholder="$config('NAME')"
                        class="mb-6"
                        required
                    ></form-input>

                    <form-input
                        name="email"
                        v-model="email"
                        type="email"
                        :placeholder="$config('EMAIL')"
                        class="mb-6"
                        required
                    ></form-input>

                    <form-input
                        name="password"
                        v-model="password"
                        type="password"
                        :placeholder="$config('PASSWORD')"
                        class="mb-6"
                        required
                    ></form-input>

                    <div class="flex flex-col items-center">
                        <p
                            class="font-secondary text-blue-light font-semibold mb-6"
                        >
                            {{ $config("PAY_TODAY") }}
                        </p>

                        <div>
                            <btn
                                class="rounded-large bg-yellow hover:bg-yellow-dark text-xl text-white px-10 sm:px-20"
                                >{{ $config("PROCESS_REGISTRATION") }}</btn
                            >
                        </div>
                    </div>
                </form>
            </ValidationObserver>
        </div>

        <timeline class="mb-8 sm:mb-16 md:mb-32 lg:mb-0"></timeline>
    </div>
</template>

<script>
import allowGuestsOnly from "../../mixins/allowGuestsOnly";
import BackButton from "../../components/BackButton";
import FormInput from "../../components/FormInput";
import BrushStrokeBg from "../../components/BrushStrokeBg";
import Btn from "../../components/Btn";
import Timeline from "../../components/Timeline";
import api from "../../api";

export default {
    name: "register-sign-up",

    components: { BackButton, FormInput, BrushStrokeBg, Btn, Timeline },

    mixins: [allowGuestsOnly],

    data() {
        return {
            password: null
        };
    },

    methods: {
        async register() {
            this.$swal({
                title: `${this.$config("REGISTRANDO")}...`,
                text: this.$config("WAIT"),
                showConfirmButton: false,
                allowOutsideClick: false
            });

            let r = await api.registerUser(
                this.name,
                this.email,
                this.password
            );

            if (!r.success) {
                this.$swal({
                    text: r.message,
                    icon: "warning",
                    confirmButtonText: "OK",
                    closeOnConfirm: true
                });

                return;
            }

            this.$store.commit("SET_AUTHENTICATED_USER", r.userdata);
            this.$store.commit("SET_AUTHENTICATED_USER_ACCESS", r.access);

            this.name = "";
            this.email = "";

            this.$swal({
                title: this.$config("U_REG"),
                icon: "success",
                showConfirmButton: false,
                allowOutsideClick: false,
                timer: 2000
            });

            this.$router.push({ name: "register-payment" });
        }
    },

    computed: {
        name: {
            get() {
                return this.$store.state.userRegistrationData.name;
            },

            set(value) {
                this.$store.commit("SET_USER_REGISTRATION_NAME", value);
            }
        },

        email: {
            get() {
                return this.$store.state.userRegistrationData.email;
            },
            set(value) {
                this.$store.commit("SET_USER_REGISTRATION_EMAIL", value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.register {
    background-image: url("~@/assets/img/fondos_pinguiigluu.jpg");
}

.paco {
    right: 7%;
    bottom: 37%;

    @media (max-width: 1024px) {
        right: 20%;
        bottom: 0;
    }
}
</style>
